/* Header country disclosure. Form submission is handled natively by Shopify. */
(() => {
  if (customElements.get('custom-country-selector')) return;

  customElements.define('custom-country-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.details = this.querySelector('[data-country-details]');
      this.trigger = this.querySelector('[data-country-trigger]');
      this.options = [...this.querySelectorAll('[data-country-option]')];
      this.trigger.setAttribute('aria-expanded', String(this.details.open));

      this.details.addEventListener('toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) {
          (this.querySelector('[aria-current="true"]') || this.options[0]).focus({ preventScroll: true });
        }
      }, { signal });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
          return;
        }
        const index = this.options.indexOf(document.activeElement);
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % this.options.length;
        if (event.key === 'ArrowUp') next = (index - 1 + this.options.length) % this.options.length;
        if (this.details.open && event.key === 'Home') next = 0;
        if (this.details.open && event.key === 'End') next = this.options.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        if (!this.details.open) this.details.open = true;
        else this.options[next].focus();
      }, { signal });

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close(false);
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close(this.contains(document.activeElement));
      }, { signal });
      window.addEventListener('resize', () => this.close(this.contains(document.activeElement)), { signal });
    }

    close(restoreFocus) {
      if (!this.details.open) return;
      this.details.open = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
})();
